import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Button } from 'components/ui/button';
import { DEFAULT_FLOW_THEME_ID, isFlowThemeId } from 'components/QuestionFlow/themes';
import { FlowThemePreviewDialog } from './FlowBuilder/FlowThemePicker';

/** Shareable previews for Course Factory authors; browsing never changes content. */
const ThemePreview: React.FC = () => {
  const { themeId } = useParams<{ themeId: string }>();
  const navigate = useNavigate();
  const returnToContent = () => navigate('/admin/content', { replace: true });

  if (!isFlowThemeId(themeId)) {
    return (
      <main className="mx-auto flex min-h-screen max-w-xl flex-col justify-center gap-4 px-6" data-testid="theme-preview-unknown">
        <h1 className="text-2xl font-semibold">Theme unavailable</h1>
        <p className="text-muted-foreground">
          This theme is not available on this site. Browse the existing themes to choose a look for your course or modules.
        </p>
        <div className="flex flex-wrap gap-3">
          <Button onClick={() => navigate(`/admin/themes/${DEFAULT_FLOW_THEME_ID}/preview`, { replace: true })}>
            Browse themes
          </Button>
          <Button variant="secondary" onClick={returnToContent}>Return to Content</Button>
        </div>
      </main>
    );
  }

  return (
    <FlowThemePreviewDialog
      themeId={themeId}
      onThemeChange={(next) => navigate(`/admin/themes/${next}/preview`, { replace: true })}
      onClose={returnToContent}
    />
  );
};

export default ThemePreview;
